// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"de100caf","602":"c38c3700","703":"bb72deac"}[chunkId] + ".chunk.js";
};